export class ClientError extends Error {
  readonly errorData: Record<string, any>;

  constructor(data: Record<string, any>) {
    if (data.message !== undefined || data.msg !== undefined) {
      super((data.message || data.msg).replace('[', '')
        .replace(']', '')
        .replace('\'', '')
        .replace('.\'', '.'));
    } else {
      super(data.message || data.msg);
    } 
    this.errorData = data || {};
  }
}
